<template>
  <div>      
    <p>Tack, du kommer inte längre få dessa mejl för Bridgen.</p>
    <p style="font-size:11px;text-align:center;">(Du skickas vidare automatiskt om {{ seconds }} sekunder)</p>
  </div>
</template>

<script>
  import { SpringSpinner } from 'epic-spinners'
  import { cloud } from '../http.js'

  export default {
    name: 'cancel-offline-email',
    components: {
      SpringSpinner
    },
    data () {
      return {
        seconds: 3
      }
    },
    async created () {
      const interval = setInterval(() => {
        this.seconds -= 1

        if (this.seconds < 1) {
          clearInterval(interval)
          this.$router.push({
            name: 'startpage'
          })
          return
        }
      }, 1000)
      
      cloud.get('account/offline/' + this.uid)
    },
    methods: {
      back () {
        this.$router.go(-1)
      }
    },
    computed: {
      uid () {
        return this.$route.params.uid
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cancel-offline-email.vue